

























































































































import Vue from 'vue';
import SubscribeForUpdatesDialog from '@/components/Utilities/SubscribeForUpdatesDialog.vue';

export default Vue.extend({
  name: 'App',
  data: () => ({
    links: [
      // { title: 'About', url: '/about' },
      // { title: 'Project Status', url: '/projectstatus' },
      // { title: 'Virtual Public Hearing', url: '/vph' },
      // { title: 'Get Involved', url: '/getinvolved' },
      // { title: 'FAQs', url: '/faqs' },
      // { title: 'Images', url: '/imagegallery' },
      { title: 'Environmental Documents', url: '/documentlibrary' },
    ],
    // footerItems: [
    //   { title: 'Project Phone: 225-366-9645', url: '' },
    //   { title: 'Project Email: CalcasieuBridge@hntb.com', url: '' },
    //   { title: 'Tell Us What You Think', url: '/getinvolved' },
    //   { title: 'Subscribe To Project Updates', url: '' },
    // ],
    modalVisible: false as boolean,
  }),
  components: {
    SubscribeForUpdatesDialog,
  },
  computed: {
    showLeftLogo(): boolean {
      // return window.innerWidth > 1280 || this.$vuetify.breakpoint.name === 'sm';
      return this.$vuetify.breakpoint.mdAndUp || this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    hideModal() {
      this.modalVisible = false;
    },
  },
});
